<template>


    <!-- Tabs with underline -->
    <div>
        <div class="form-control sm:hidden">
            <label for="tabs" class="label">Select a tab</label>
            <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
            <select id="tabs" name="tabs" class="select">
                <option>All</option>

                <option>Succeeded</option>

                <option selected>Refunded</option>

                <option>Suspicious</option>

                <option>Failed</option>
            </select>
        </div>
        <div class="hidden sm:block">
            <div class="border-b border-neutral-200">
                <nav class="-mb-px flex space-x-8" aria-label="Tabs">
                    <!-- Current: "tab-link_active", Default: "border-transparent tab-link_inactive" -->
                    <a href="#" class="tab-link tab-link_active"> All </a>

                    <a href="#" class="tab-link tab-link_inactive"> Succeeded </a>

                    <a href="#" class="tab-link tab-link_inactive" aria-current="page"> Refunded </a>

                    <a href="#" class="tab-link tab-link_inactive"> Suspicious </a>

                    <a href="#" class="tab-link tab-link_inactive"> Failed </a>
                </nav>
            </div>
        </div>
    </div>


</template>